import { Spinner } from "react-bootstrap";
import { Input } from "../index.js";
import { useEffect, useState } from "react";

const SwitchWithLoader = ({ isChecked, onChange }) => {
  const [isLoading, setIsLoading] = useState(false);
  // const [status, setStatus] = useState(true); // todo: Alpha
  useEffect(() => {
    setIsLoading(false);
  }, [isChecked]);

  const handler = async () => {
    setIsLoading(true);
    onChange();
    await new Promise((resolve) => setTimeout(resolve, 2000));
    // setStatus(!status);
    setIsLoading(false);
  };

  if (isLoading) {
    return (
      <Spinner
        size="sm"
        style={{ marginLeft: "10px", verticalAlign: "middle" }}
      />
    );
  }

  return (
    <label className="switch">
      <Input
        type="checkbox"
        checked={isChecked}
        // checked={status}
        disabled={isLoading} // Disable the switch while loading
        // onChange={onChange}
        onChange={handler}
      />
      <span className="slider round"></span>
      {isLoading && (
        <Spinner
          size="sm"
          style={{ marginLeft: "10px", verticalAlign: "middle" }}
        />
      )}
    </label>
  );
};

export default SwitchWithLoader;
